export default {
    en: {
        number: 11,
        diagramId: 10,
        answers: 'clouds contain droplets droplets must coalesce droplets can’t coalesce',
        interactiveBoxNumber: [1, 2],
        blocks:
            [
                {
                    task: {
                        question: 'Clouds that could produce rain contain micron-size droplets of water, kept aloft by updrafts',
                        answer: '<span class="correct-answer-box correct-answer-box_11">Clouds that could produce rain contain micron-size <span class="highlight__answer highlight__answer_correct">clouds contain droplets</span> of water, kept aloft by updrafts</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'To escape the updrafts, droplets must coalesce into ice pellets',
                        answer: '<span class="correct-answer-box correct-answer-box_11">To escape the updrafts, <span class="highlight__answer highlight__answer_correct">droplets must coalesce</span> into ice pellets</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'The droplets can’t coalesce without dust particles to serve as nuclei',
                        answer: '<span class="correct-answer-box correct-answer-box_11">The <span class="highlight__answer highlight__answer_correct">droplets can’t coalesce</span> without dust particles to serve as nuclei</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'To get rain, we mimic the dust particles with silver iodide',
                        answer: '<span class="correct-answer-box correct-answer-box_11">To get rain, we mimic the dust particles with silver iodide</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise11.js